import { Brain, Folder, House, ScanSearch } from "lucide-react"

import { NavigationSectionModel } from "@models/navigations"

export const APPLICATION_SECTION: NavigationSectionModel = {
    title: "Application",
    items: [
        { title: "Dashboard", tooltip: "Dashboard", url: "/", icon: House },
        { title: "Content", tooltip: "Browse Content", url: "/search", icon: ScanSearch },
        { title: "Collections", tooltip: "Browse Collections", url: "/collections", icon: Folder },
    ],
}

export const APPLICATION_ADVANCED_SECTION: NavigationSectionModel = {
    title: "Advanced",
    items: [{ title: "Assistant", tooltip: "Assistant", url: "/assistant", icon: Brain }],
}
